import { IBrandingOption } from "../app/interface/options/brandingOption";

export const BrandingOptions: Array<IBrandingOption> = [
    {
        name: 'Default',
        primary: '#17784c',
        secondary: '#0096b8'
    },
    {
        name: 'Summer Breeze',
        primary: '#55b1f7',
        secondary: '#e9ce50'
    },
    {
        name: 'Auvergine',
        primary: '#5aaf27',
        secondary: '#832ebc'
    },
    {
        name: 'Autumn Dreams',
        primary: '#6c996b',
        secondary: '#996b6c'
    },
    {
        name: 'Candy Factory',
        primary: '#6a28d7',
        secondary: '#ff80c0'
    }
]